import { getStore, setStore } from '@/util/store';
import { getDictionary } from '@/api/system/dict';
var dict = {
  state: {
    flowRoutes: getStore({
      name: 'flowRoutes'
    }) || {}
  },
  actions: {
    FlowRoutes: function FlowRoutes(_ref) {
      var commit = _ref.commit;
      return new Promise(function (resolve, reject) {
        getDictionary({
          code: 'flow'
        }).then(function (res) {
          commit('SET_FLOW_ROUTES', res.data.data);
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  },
  mutations: {
    SET_FLOW_ROUTES: function SET_FLOW_ROUTES(state, data) {
      state.flowRoutes = data.map(function (item) {
        return {
          routeKey: "".concat(item.code, "_").concat(item.dictKey),
          routeValue: item.remark
        };
      });
      setStore({
        name: 'flowRoutes',
        content: state.flowRoutes
      });
    }
  }
};
export default dict;